<template>
  <div
    v-if="showModal"
    class="modal fixed w-full h-full top-0 left-0 flex items-center justify-center z-50"
  >
    <!-- Overlay -->
    <div
      class="modal-overlay absolute w-full h-full bg-gray-900 opacity-50"
    ></div>

    <!-- Modal Container -->
    <div
      class="modal-container bg-white w-11/12 md:max-w-md mx-auto rounded shadow-lg z-50 overflow-y-auto"
    >
      <!-- Modal Content -->
      <div class="modal-content text-left">
        <!-- Title -->
        <div class="flex justify-between items-center bg-red-700 p-4">
          <p class="text-2xl font-bold text-white">{{ title }}</p>
        </div>

        <!-- Body -->
        <div class="p-4">
          <p>{{ message }}</p>
        </div>

        <!-- Footer -->
        <div class="flex flex-col gap-2 p-4">
          <button
            class="w-full button py-2 bg-red-700 text-white hover:bg-red-600"
            @click="onClose"
          >
            {{ closeText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SessionTimeoutModal",
  props: {
    showModal: {
      type: Boolean
    },
    title: {
      type: String
    },
    message: {
      type: String
    },
    closeText: {
      type: String
    },
    onClose: {
      type: Function
    }
  }
};
</script>
